import React from 'react';
import { Typography, Grid } from '@mui/material';
import { useDataProvider, useRecordContext } from 'react-admin';
import { ShsToggle, ShsTextInput, ShsPhoneInput } from 'src/components/common';
import { CenterFormFields } from 'src/constants/centers';

const createLengthValidator = (min: number, max: number, label: string) => {
    return (value: string) => {
        if (!value) return;
        if (value.length < min) return `${label} не може бути менше ${min} символів`;
        if (value.length > max) return `${label} не може перевищувати ${max} символів`;
    };
};

const createCenterNameValidator = (min: number, max: number, dataProvider: any, record: any, label: string) => {
    const baseValidate = createLengthValidator(min, max, label);

    return async (value: string) => {
        const error = baseValidate(value);
        if (error) return error;

        const response = await dataProvider.getList('centers', {
            filter: { keyword: value, 'filters.active': true },
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'name', order: 'ASC' }
        });

        const existing = response.data.find(
            (c: any) => (c.name === value || c.shortName === value) && c.id !== record?.id
        );

        if (existing) return 'Вказана назва вже є в системі';
    };
};

export const GeneralCenterInfo: React.FC = () => {
    const dataProvider = useDataProvider();
    const record = useRecordContext();

    const validateName = createCenterNameValidator(3, 300, dataProvider, record, 'Назва');
    const validateShortName = createCenterNameValidator(3, 100, dataProvider, record, 'Скорочена назва');
    const validateCity = createLengthValidator(3, 50, 'Назва міста');
    const validateAddress = createLengthValidator(3, 300, 'Адреса');
    const validatePhone = (value: string) => {
        if (!value) return;
        if (value.length > 13) {
            return 'Невірний формат';
        }
    };

    return (
        <>
            <Typography variant="h5" component="h6" mb={3} fontWeight="600">
                Статус
            </Typography>
            <Grid container columnSpacing={4} rowSpacing={1}>
                <Grid item xs={12}>
                    <ShsToggle source={CenterFormFields.ACTIVE} label="Активний" />
                </Grid>
            </Grid>
            <Typography variant="h5" component="h6" mb={3} fontWeight="600">
                Інформація про центр
            </Typography>
            <Grid container columnSpacing={4} rowSpacing={1}>
                <Grid item xs={12}>
                    <ShsTextInput source={CenterFormFields.NAME} label="Назва" required validate={validateName} />
                </Grid>
                <Grid item xs={6}>
                    <ShsTextInput
                        source={CenterFormFields.SHORT_NAME}
                        label="Скорочена назва"
                        required
                        validate={validateShortName}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ShsPhoneInput
                        source={CenterFormFields.PHONE}
                        label="Контактний номер телефону"
                        required
                        validate={validatePhone}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ShsTextInput source={CenterFormFields.CITY} label="Місто" required validate={validateCity} />
                </Grid>
                <Grid item xs={6}>
                    <ShsTextInput
                        source={CenterFormFields.ADDRESS}
                        label="Адреса"
                        required
                        validate={validateAddress}
                    />
                </Grid>
            </Grid>
        </>
    );
};
